import React from 'react';
import { motion } from 'framer-motion';

const Welcome = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          {/* Small label */}
          <motion.span
            className="inline-flex items-center gap-2 px-4 py-1 mb-4 text-xs tracking-[0.25em] uppercase bg-gray-900 text-gray-100 rounded-full"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <span className="h-1.5 w-1.5 rounded-full bg-amber-400" />
            <span>About Sudharma Group</span>
          </motion.span>

          {/* Title */}
          <motion.h2
            className="text-3xl md:text-4xl font-playfair font-bold text-gray-900 mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            A Legacy of Quality Garment Manufacturing Since 1999
          </motion.h2>

          {/* Main text */}
          <motion.p
            className="mb-4 text-lg leading-relaxed text-gray-700"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.25 }}
          >
            Sudharma Group was established in 1999 as a garment manufacturing
            unit. During the early days, the company focused on producing
            garments for the domestic market. To meet growing in-house demand,
            a knitting unit was installed in 2008.
          </motion.p>

          <motion.p
            className="mb-4 text-lg leading-relaxed text-gray-700"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.35 }}
          >
            By 2009, through hard work and a strong commitment to quality, the
            company began exporting garments. Today, Sudharma manufactures a
            wide range of garments for men, women and children, and is known
            industry-wide for its premium quality and on-trend designs.
          </motion.p>

          <motion.p
            className="mb-6 text-lg leading-relaxed text-gray-700"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.45 }}
          >
            The company continues to grow under the leadership of{' '}
            <span className="font-semibold text-gray-900">
              Mr. Suresh Jain
            </span>{' '}
            and{' '}
            <span className="font-semibold text-gray-900">
              Mr. Navneet Jain
            </span>
            . With a strong workforce, expansive manufacturing facilities and a
            deep focus on innovation, Sudharma Clothing Co. proudly supplies
            markets throughout India and abroad.
          </motion.p>

          {/* Highlight chips */}
          <motion.div
            className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-4 border-t border-gray-200"
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.55 }}
          >
            <div className="bg-white rounded-lg shadow-sm px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">
                Established
              </p>
              <p className="text-lg font-semibold text-gray-900">1999</p>
            </div>
            <div className="bg-white rounded-lg shadow-sm px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">
                In-house Knitting
              </p>
              <p className="text-lg font-semibold text-gray-900">Since 2008</p>
            </div>
            <div className="bg-white rounded-lg shadow-sm px-4 py-3">
              <p className="text-xs uppercase tracking-wide text-gray-500">
                Export Garments
              </p>
              <p className="text-lg font-semibold text-gray-900">Since 2009</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Welcome;
